/**
 * Reading the per-resource document counts off a release.
 *
 * `metadata` is keyed by snapshot resource_type — `drug_programs`,
 * `item_prices`, and so on. Releases published before the metadata bug was
 * fixed have no metadata at all (the schema declared `*_count` keys while the
 * service wrote un-suffixed ones, so strict mode dropped every assignment), so
 * callers get an empty list rather than a row of zeros. The `*_count` spelling
 * is still read in case any release was written under a corrected old shape.
 */

const COUNT_LABELS = [
  ['drug_programs', 'programs'],
  ['pharmacies', 'pharmacies'],
  ['physicians', 'physicians'],
  ['program_categories', 'categories'],
  ['item_families', 'item families'],
  ['items', 'items'],
  ['item_prices', 'prices'],
  ['coupons', 'coupons'],
]

/**
 * @returns {Array<{key: string, label: string, count: number}>} only the
 *   resource types this release actually recorded.
 */
export function releaseCounts(release) {
  const metadata = release?.metadata
  if (!metadata) return []

  return COUNT_LABELS
    .map(([key, label]) => ({
      key,
      label,
      count: metadata[key] ?? metadata[`${key}_count`] ?? null,
    }))
    .filter(({ count }) => typeof count === 'number')
}
